@if(event.introArticle){
  <app-event-intro-article [data]="event.introArticle"></app-event-intro-article>
} 
@if(event.mainSponsors && event.mainSponsors.sponsors && event.mainSponsors.sponsors.length > 0){
  <app-sponsor-banner [data]="event.mainSponsors"></app-sponsor-banner>
}
@if(event.infoArticle){
  <app-event-info-article [data]="event.infoArticle"></app-event-info-article>
}

@if(event.sections){
  <app-sections [data]="event.sections"></app-sections>
}

<div *ngIf="sponsors$ | async as sponsors">
  <app-sponsor-banner *ngIf="event?.showSponsors" [data]="{sponsors: sponsors}"></app-sponsor-banner>
</div>